module.exports = __webpack_public_path__ + "static/media/giving.edd6e1e5.gif";